import { render } from "./Tariff.vue?vue&type=template&id=7ec07947&scoped=true"
import script from "./Tariff.vue?vue&type=script&lang=js"
export * from "./Tariff.vue?vue&type=script&lang=js"

import "./Tariff.vue?vue&type=style&index=0&id=7ec07947&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec07947"]])

export default __exports__